import styled from "styled-components";
import ntv_sport from "assets/img/sponsor/de/ntv_sport.png";

const Wrapper = styled.div`
	background: linear-gradient(90deg, #0e0051 0%, #092fae 100%);
	padding: 16px;
	display: flex;
	flex-flow: row;
	align-items: center;
	justify-content: center;
	img {
		height: 48px;
		max-width: 174px;
	}
`;

export const TopDeSponsor = () => {
	return (
		<Wrapper>
			<img src={ntv_sport} alt="ntv_sport" />
		</Wrapper>
	);
};
